<script setup lang="ts">
const items = [
  {
    title: 'Pembayaran Instan',
    description: 'Tim langsung proses tanpa tunggu izin',
    icon: 'ic:outline-payments'
  },
  {
    title: 'Kendali Penuh',
    description: 'Atur limit saldo & user sesuai kebutuhan.',
    icon: 'material-symbols:manage-accounts-outline'
  },
  {
    title: 'Multi-User Akses',
    description: 'Staff bisa kirim, owner tetap bisa pantau',
    icon: 'material-symbols:groups-outline'
  },
  {
    title: 'Laporan Otomatis',
    description: 'Semua transaksi tercatat transparan di dashboard',
    icon: 'material-symbols:description-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Efisien untuk Tim, Aman untuk Owner"
    hero-image="/images/ka-kredit-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
